import { FC } from 'react';

import { USER_INSIGHTS_RUM_ATTRIBUTES } from 'modules/legacySegmentation/constants';
import { RemountableErrorBoundary } from 'modules/error';

import { ErrorMessage } from './ErrorMessage';

export const AudienceInsightsErrorBoundary: FC<
  React.PropsWithChildren<unknown> & { isSection?: boolean }
> = ({ children, isSection = false }) => (
  <RemountableErrorBoundary
    errorMarkup={({ isRemounting, remount }) => (
      <ErrorMessage isSection={isSection} isRefreshing={isRemounting} refresh={remount} />
    )}
    {...USER_INSIGHTS_RUM_ATTRIBUTES}
  >
    {children}
  </RemountableErrorBoundary>
);
